// Re-export unified AssetPickerModal configured for videos
import { AssetPickerModal } from '@/components/features/shared'
import type { Asset } from '@/types'

interface VideoPickerModalProps {
  isOpen: boolean
  onClose: () => void
  onSelect: (asset: Asset) => void
}

export function VideoPickerModal({ isOpen, onClose, onSelect }: VideoPickerModalProps) {
  return (
    <AssetPickerModal
      isOpen={isOpen}
      onClose={onClose}
      onSelect={onSelect}
      assetType="video"
    />
  )
}
